import { Box } from "@mantine/core";

// A small colour-tinted square used to give every dashboard module's icon the same visual
// treatment - a solid-coloured icon sitting on top of a soft tint of that same colour - rather
// than each module styling (or not styling) its icon differently. Falls back to a neutral grey
// tint when no colour is supplied.
export default function IconBadge({ icon, color, size = 36 }) {
  const isHex = typeof color === "string" && color.startsWith("#");

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        borderRadius: theme.radius.md,
        flexShrink: 0,
        backgroundColor: isHex
          ? `${color}1a`
          : theme.colorScheme === "dark"
          ? theme.colors.dark[5]
          : theme.colors.gray[1],
      })}
    >
      {icon}
    </Box>
  );
}
